/**
 * Base Plugin class that all plugins should extend
 * Provides the contract and common functionality for plugins
 */
class Plugin {
  constructor(editor, options = {}) {
    this.editor = editor;
    this.options = options;
    this.name = 'Plugin';
    this.enabled = false;
  }

  /**
   * Initialize the plugin
   * Called when the plugin is registered
   */
  init() {
    this.enabled = true;
  }

  /**
   * Destroy the plugin and clean up resources
   * Called when the plugin is unloaded or editor is destroyed
   */
  destroy() {
    this.enabled = false;
  }

  /**
   * Get toolbar buttons for this plugin
   * @returns {Array} Array of button definitions
   */
  getToolbarButtons() {
    return [];
  }

  /**
   * Execute a command from this plugin
   * @param {string} command - Command name
   * @param {*} value - Optional command value
   */
  // eslint-disable-next-line no-unused-vars
  executeCommand(command, value) {
    // eslint-disable-line no-unused-vars
    // Override in subclasses
  }

  /**
   * Get CSS for this plugin
   * @returns {string} CSS string or empty string
   */
  getStyles() {
    return '';
  }

  /**
   * Handle keyboard shortcuts for this plugin
   * @param {KeyboardEvent} event
   * @returns {boolean} true if event was handled
   */
  // eslint-disable-next-line no-unused-vars
  handleKeyboard(event) {
    // eslint-disable-line no-unused-vars
    return false;
  }

  /**
   * Get plugin metadata
   * @returns {Object} Plugin metadata
   */
  getMetadata() {
    return {
      name: this.name,
      version: '1.0.0',
      description: '',
      author: '',
    };
  }
}

export default Plugin;
